import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { ACCOUNTING_PAYMENT_TYPE_COLUMN, ACCOUNTING_PAYMENT_TYPE_MODULE } from "../constants/accountSettingsConstants";

export const setAccountingPaymentTypePreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: ACCOUNTING_PAYMENT_TYPE_MODULE,
        default_columns: ACCOUNTING_PAYMENT_TYPE_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
